module.exports = __webpack_public_path__ + "img/article_3_1.e34ad2b6.png";